import { ValidateJSModel, YesOrNoModel } from 'forms/shared/types';
import { branch } from 'config/locales/en/branch';

const branchModelValidator: ValidateJSModel<YesOrNoModel> = {
  value: (value, attributes, attributeName, options) => {
    const additionalValidation = !options.ignoreBranch && value && value !== branch.value.no ? {
      requireTrue: { // force error message; value will never be true
        message: 'branch.additionalEntry',
      }
    } : {};
    return {
      ...additionalValidation,
      presence: !options.ignoreBranch,
    };
  },
};

export default branchModelValidator;
